export const dataArray = [
  {
    title: "Potato Chips",
    date: "12/3/2023",
    price: 10,
  },
  {
    title: "Chocolate Bars",
    date: "22/7/2024",
    price: 15,
  },
  {
    title: "Soda Cans",
    date: "05/11/2023",
    price: 8,
  },
  {
    title: "Mixed Nuts",
    date: "18/4/2024",
    price: 12,
  },
  {
    title: "Popcorn",
    date: "29/9/2023",
    price: 20,
  },
  {
    title: "Beef Jerky",
    date: "14/1/2024",
    price: 7,
  },
  {
    title: "Granola Bars",
    date: "27/8/2024",
    price: 9,
  },
  {
    title: "Candy",
    date: "02/6/2023",
    price: 18,
  },
  {
    title: "Trail Mix",
    date: "19/12/2023",
    price: 13,
  },
  {
    title: "Cookies",
    date: "08/2/2023",
    price: 11,
  },
  {
    title: "Pretzels",
    date: "31/10/2024",
    price: 16,
  },
  {
    title: "Crackers",
    date: "09/5/2023",
    price: 14,
  },
  {
    title: "Potato Chips",
    date: "25/7/2024",
    price: 6,
  },
  {
    title: "Chocolate Bars",
    date: "03/9/2023",
    price: 19,
  },
  {
    title: "Soda Cans",
    date: "20/1/2024",
    price: 5,
  },
  {
    title: "Mixed Nuts",
    date: "07/8/2023",
    price: 17,
  },
];
